/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// utils
// material
import { Button } from '@insticator/insticator-ui';
import { ReactComponent as UpgradeIcon } from 'assets/icons/upgrade.svg'
import { ReactComponent as Alert } from 'assets/icons/alert-triangle.svg'

// styles
import injectSheet from "react-jss";
import styles from './failed_styles';

/* ========== ~~~~~~~~~~ MIGRATION STATUS WIDGET : FAILED ~~~~~~~~~~ ========== */
const Failed  = injectSheet(styles)((props) => {
  const dispatch = useDispatch();

  return (
    <div className={`inprogress ${props.classes.inprogress}`}>
      <div className='info'>
        <span className='icon'><UpgradeIcon height={30} width={30} /></span>
        <p className='text'>Commenting 2.0 Migration Status</p>
      </div>
      <div className='actions'>
        <Button name={'failed'} text={<span><Alert /> Failed</span>}  />
        <p className='failedmessage'>The team has been notified and is looking into this</p>
      </div>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Failed